import React, { useState, useEffect } from "react";
import "../../assets/css/candidate-tab-form.css";
import "../../assets/css/inner-tabs.css";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import Loader from "../Common/loader";
import { useNavigate } from "react-router-dom";
import WORKText from "./workText";
import WORKSingleFileUpload from "./workSingleFileUpload";
import {
  saveEligibility,
  deleteEligibility,
} from "../../Actions/eligiblitityToWorkActions";

const MainForm = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { eligibilityWork, active } = props;
  const [loading, setLoading] = useState(false);
  const [eligibility, setEligibility] = useState({});
  const [errorData, setErrorData] = useState([]);
  const [activeTab, setActiveTab] = useState(1);
  const storeData = useSelector((state) => state.eligibilitySaveData);
  const { eligibilitySaveData, loading: eligibilitySaveDataLoading } =
    storeData;
  const [uploadedFilesCount, setUploadedFilesCount] = useState({});
  const [currentField, setCurrentField] = useState(null);
  const [unsavedErrorData, setUnsavedErrorData] = useState({});

  let user = JSON.parse(localStorage.getItem('userVerificationCandidate'));
  let clientId;

  if(user && (user?.client_id || user?.bridge_client_id)){
    clientId = user?.client_id || user?.bridge_client_id;  
  }

  useEffect(() => {
    setEligibility(eligibilityWork);
  }, [eligibilityWork]);

  useEffect(() => {
    if (
      typeof eligibilitySaveData.data !== "undefined" &&
      eligibilitySaveData.data !== null
    ) {
      const group = eligibilitySaveData.data.group
        ? eligibilitySaveData.data.group.group_id
        : "";
      const reference = eligibilitySaveData.data.reference_number;
      if (group == "profile_preview") {
        navigate(`/case-initiation/profile-preview/${reference}`);
        dispatch(deleteEligibility());
      } else if (typeof group != "undefined" && group != "") {
        navigate(`/case-initiation/check-detail/${reference}/${group}`);
        dispatch(deleteEligibility());
      }
    }
  }, [eligibilitySaveData]);

  useEffect(() => {
    setLoading(props.isLoading);
  }, [props.isLoading]);

  const handleTextChange = (textValues) => {
    const { dataset, value } = textValues;
    setCurrentField(dataset.fieldname);
    let newData = Object.assign({}, errorData);
    if (value != "") {
      newData[dataset.fieldname] = false;
    } else {
      newData[dataset.fieldname] = true;
    }
    // let ele = document.getElementById(dataset.errorid);
    // if (typeof(ele) != 'undefined' && ele != null) {
    //   ele.innerHTML = '';
    // }
    setErrorData(newData);
    setUnsavedErrorData(newData);
    updateEligibilityDetails(dataset, value);
  };

  const updateEligibilityDetails = (dataset, value) => {
    let eligible = _.cloneDeep(eligibility);
    eligible.checksDetails[parseInt(dataset.checkdetailsindex)].fields[
      dataset.fieldname
    ].field_value = value;
    setEligibility(eligible);
  };

  const saveHandler = async (e, caseCheckId, index) => {
    props.setIsLoading(true);
    e.preventDefault();
    let hasError = false;
    let errorArr = [];
    if (
      typeof eligibility.checksDetails !== "undefined" &&
      eligibility.checksDetails !== null
    ) {
      const checksDetails = eligibility.checksDetails;
      for (var j in checksDetails[0].fields) {
        if (j !== "eow_eligible_question") {
          if (
            checksDetails[0].fields[j].is_mandatory == 1 &&
            (checksDetails[0].fields[j].field_value.trim() == "" ||
              checksDetails[0].fields[j].field_value == null)
          ) {
            hasError = true;
            errorArr[j] = true;
          } else {
            errorArr[j] = false;
          }
        }
      }

      //for (var j in checksDetails[0]) {
      //for (var k in checksDetails[0].required_documents) {
      if (
        checksDetails[0].required_documents[0].is_mandatory == 1 &&
        uploadedFilesCount[0][checksDetails[0].required_documents[0].id] == 0
      ) {
        hasError = true;
        errorArr[`${checksDetails[0].required_documents[0].id}`] = true;
      } else {
        errorArr[`${checksDetails[0].required_documents[0].id}`] = false;
      }
      //}
      //}
    }
    setErrorData(errorArr);
    if (hasError == true) {
      props.setIsLoading(false);
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
      return;
    } else {
      saveEligibilityDetails(index - 1, caseCheckId);
    }
  };

  const saveEligibilityDetails = (checksDetailsIndex, caseCheckId) => {
    let savedDetailsObj = {};
    const fieldDetails = _.cloneDeep(
      eligibility.checksDetails[checksDetailsIndex].fields
    );
    savedDetailsObj["group"] = "eligibility_work_details";
    for (var i in fieldDetails) {
      if (
        fieldDetails[i].field_value.trim() !== "" &&
        fieldDetails[i].field_value !== null
      ) {
        savedDetailsObj[`${fieldDetails[i].id}`] = fieldDetails[i].field_value;
      }
    }
    props.setIsLoading(false);
    let finalData = {};
    finalData[`${caseCheckId}`] = savedDetailsObj;
    dispatch(saveEligibility(caseCheckId, finalData, activeTab));
  };

  const getUpdatedEligibilityData = () => {
    props.reRenderAgain(eligibility);
  };

  // const reRenderAgain = () => {
  //   props.reRenderAgain(eligibility);
  // };

  useEffect(() => {
    if (
      typeof eligibilityWork.checksDetails !== "undefined" &&
      eligibilityWork.checksDetails !== null
    ) {
      const checksDetails = eligibilityWork.checksDetails;
      getUploadedFilesCount(checksDetails);
      let errorArr = [];
      for (var j in checksDetails[0].fields) {
        errorArr[j] = false;
      }
      if (Object.keys(unsavedErrorData).length == 0) {
        setErrorData(errorArr);
      } else {
        const newErr = Object.assign({}, unsavedErrorData);
        newErr[currentField] = false;
        setErrorData(newErr);
      }
    }
  }, [eligibilityWork, eligibility]);

  const getUploadedFilesCount = (checksDetails) => {
    let uploadedFilesCount = {};
    for (let i in checksDetails) {
      let obj = {};
      for (let j in checksDetails[i].required_documents) {
        let count = 0;
        for (let k in checksDetails[i].uploaded_documents) {
          if (
            checksDetails[i].uploaded_documents[k].document_id ==
            checksDetails[i].required_documents[j].id
          ) {
            count++;
          }
        }
        obj[`${checksDetails[i].required_documents[j].id}`] = count;
      }
      uploadedFilesCount[i] = obj;
    }
    const case_check_id = checksDetails[0]["case_check_id"];
    const doc_id = checksDetails[0]["required_documents"][0]["id"];
    if (uploadedFilesCount[0][doc_id] > 0) {
      const error_id = "err_" + case_check_id + "_" + doc_id;
      let ele = document.getElementById(error_id);
      if (typeof ele != "undefined" && ele != null) {
        ele.innerHTML = "";
      }
    }
    setUploadedFilesCount(uploadedFilesCount);
  };

  const handleSubmitForPreview = (e) => {
    e.preventDefault();
    const currentUrl = window.location.href;
    const [partA, partB] = currentUrl.split("/check-detail/");
    const [reference, route] = partB.split("/");
    navigate(`/case-initiation/profile-preview/${reference}`);
  };

  return (
    <>
      {loading && <Loader />}
      {/* <div className="d-flex justify-content-between align-items-center">
        <ul className="nav nav-tabs address-tabs" id="myTab" role="tablist">
          {activeTab &&
            Object.keys(eligibility).length > 0  && Object.entries(eligibility.checksDetails).map(([key, value]) => {
              const index = parseInt(key) + 1;
              const caseCheckId = value.case_check_id;
              const caseCheckStatus = value.check_status;
              let activeClass = "";
              if (typeof active !== "undefined") {
                if (active == index) {
                  activeClass = "active";
                }
              } else if (index === 1) {
                activeClass = "active";
              }
              let completeClass = "";
              if (caseCheckStatus === 2) {
                completeClass = "completed";
              }
              let check_name = value.IB_CHECK_NAME;
              if (check_name == '') {
                check_name = 'Eligibility to Work Details';
              }
              return (
                <li className="nav-item" key={key}>
                  <a
                    className={`tab nav-link ${activeClass} ${completeClass}`}
                    id={`work-tab-${index}`}
                    data-toggle="tab"
                    href={`#work-${index}`}
                    role="tab"
                    aria-controls={`work-${index}`}
                    aria-selected="true"
                    data-index={index - 1}
                    data-casecheckid={caseCheckId}
                    //style={{ color: caseCheckStatus == 2 ? "green" : "grey" }}
                  >
                    {caseCheckStatus === 2 && (
                      <i class="fas fa-check-circle mr-1"></i>
                    )}
                    {check_name}
                  </a>
                </li>
              );
            })}
        </ul>
      </div>
      <hr /> */}
      <div className="tab-content" id="myTabContent">
        {eligibility.checksDetails &&
          Object.entries(eligibility.checksDetails).map(([key, value]) => {
            const index = parseInt(key) + 1;
            const caseCheckId = value.case_check_id;
            let activeClass = "";
            if (typeof active !== "undefined") {
              if (active == index) {
                activeClass = "show active";
              }
            } else if (index === 1) {
              activeClass = "show active";
            }
            return (
              <div
                className={`tab-pane fade ${activeClass}`}
                id={`scot-${index}`}
                role="tabpanel"
                aria-labelledby={`scot-tab-${index}`}
                key={key}
              >
                <div className="row">
                  {value.fields.eow_working_location ? (
                    <WORKText
                      name={`eow_working_location_${caseCheckId}`}
                      id={`eow_working_location_${caseCheckId}`}
                      fieldId={
                        value.fields.eow_working_location.ibridge_field_id
                      }
                      label={value.fields.eow_working_location.label}
                      isRequired={
                        value.fields.eow_working_location.is_mandatory
                      }
                      errId={`err_${caseCheckId}_${value.fields.eow_working_location.ibridge_field_id}`}
                      handleTextChange={handleTextChange}
                      checkDetailsIndex={key}
                      fieldName={"eow_working_location"}
                      fieldValue={value.fields.eow_working_location.field_value}
                      hasError={errorData.eow_working_location}
                    />
                  ) : (
                    <></>
                  )}
                  {value.fields.eow_reference_number ? (
                    <WORKText
                      name={`eow_reference_number_${caseCheckId}`}
                      id={`eow_reference_number_${caseCheckId}`}
                      fieldId={
                        value.fields.eow_reference_number.ibridge_field_id
                      }
                      label={value.fields.eow_reference_number.label}
                      isRequired={
                        value.fields.eow_reference_number.is_mandatory
                      }
                      errId={`err_${caseCheckId}_${value.fields.eow_reference_number.ibridge_field_id}`}
                      handleTextChange={handleTextChange}
                      checkDetailsIndex={key}
                      fieldName={"eow_reference_number"}
                      fieldValue={value.fields.eow_reference_number.field_value}
                      hasError={errorData.eow_reference_number}
                    />
                  ) : (
                    <></>
                  )}
                </div>
                <div className="row">
                  {value.fields.eow_scope_of_verification ? (
                    <WORKText
                      name={`eow_scope_of_verification_${caseCheckId}`}
                      id={`eow_scope_of_verification_${caseCheckId}`}
                      fieldId={
                        value.fields.eow_scope_of_verification.ibridge_field_id
                      }
                      label={value.fields.eow_scope_of_verification.label}
                      isRequired={
                        value.fields.eow_scope_of_verification.is_mandatory
                      }
                      errId={`err_${caseCheckId}_${value.fields.eow_scope_of_verification.ibridge_field_id}`}
                      handleTextChange={handleTextChange}
                      checkDetailsIndex={key}
                      fieldName={"eow_scope_of_verification"}
                      fieldValue={
                        value.fields.eow_scope_of_verification.field_value
                      }
                      hasError={errorData.eow_scope_of_verification}
                    />
                  ) : (
                    <></>
                  )}
                  {value.fields.eow_document_number ? (
                    <WORKText
                      name={`eow_document_number_${caseCheckId}`}
                      id={`eow_document_number_${caseCheckId}`}
                      fieldId={
                        value.fields.eow_document_number.ibridge_field_id
                      }
                      label={value.fields.eow_document_number.label}
                      isRequired={value.fields.eow_document_number.is_mandatory}
                      errId={`err_${caseCheckId}_${value.fields.eow_document_number.ibridge_field_id}`}
                      handleTextChange={handleTextChange}
                      checkDetailsIndex={key}
                      fieldName={"eow_document_number"}
                      fieldValue={value.fields.eow_document_number.field_value}
                      hasError={errorData.eow_document_number}
                    />
                  ) : (
                    <></>
                  )}
                </div>
                {/* <div className="row">
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group"> */}

                <h6 className="fnt-smi-bld mb-0">Upload document</h6>
                <small>Upload your work authorization certificate</small>
                <WORKSingleFileUpload
                  name="pv_form"
                  id="pv_form"
                  title={value.required_documents[0].document_name}
                  record={{
                    caseCheckId: caseCheckId,
                    docId: value.required_documents[0].id,
                  }}
                  totalCount={
                    uploadedFilesCount[parseInt(index - 1)] &&
                    uploadedFilesCount[parseInt(index - 1)][
                      value.required_documents[0].id
                    ]
                      ? uploadedFilesCount[parseInt(index - 1)][
                          value.required_documents[0].id
                        ]
                      : 0
                  }
                  getCount={1}
                  getUpdatedEligibilityData={getUpdatedEligibilityData}
                  isMandatory={value.required_documents[0].is_mandatory}
                  errId={`err_${caseCheckId}_${value.required_documents[0].id}`}
                  hasError={errorData[value.required_documents[0].id]}
                />
                {/* </div>
                  </div>
                </div> */}
                <div className="row mt-3">
                  <div className="col-auto d-flex justify-content-between">
                    <button
                      className="btn btn-primary btn-lg btn-block mt-3"
                      onClick={(e) => saveHandler(e, caseCheckId, index)}
                    >
                      Save
                    </button>
                  </div>
                </div>
                {eligibility.showProfilePreview == 1 && (
                  <div className="row">
                    <div className="col-auto d-flex justify-content-between">
                      <button
                        className="btn btn-primary btn-lg btn-block mt-3"
                        onClick={(e) => handleSubmitForPreview(e)}
                      >
                      {clientId == 459831 ? "Preview" : "Submit for Preview"}
                      </button>
                    </div>
                    <div className="col-auto d-flex justify-content-between mt-4">
                      <small className="text-muted">
                        Please complete all the mandatory fields before final
                        submission
                      </small>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
      </div>
    </>
  );
};

export default MainForm;
